import { useEffect } from 'react';
import { useAssessmentsOverviewContext } from '../Contexts/AssessmentsOverviewContext';
import AssessmentsOverviewList from './AssessmentsOverviewList';
import { AssessmentStatuses } from '@/Models/AssessmentData';

function ActiveAssessmentsOverviewList() {
    const { filterByStatus } = useAssessmentsOverviewContext();
    useEffect(() => {
        filterByStatus(AssessmentStatuses.Active);
    }, []);

    return <AssessmentsOverviewList />;
}

export default ActiveAssessmentsOverviewList;
